<template>
  <div class="chat" v-if="!chat.fromAdmin">
    <h2>{{ chat.user }}</h2>
    <h3>{{ chat.day }}-{{ chat.month }}-{{ chat.year }}</h3>
    <h5><strong>Telnummer:</strong> {{ chat.phoneNumber }}</h5>

    <br />
    <div @click="previewFile" v-if="chat.isFile">
      <p>
        <svg-icon
          icon="paperclip"
          fill="#000000"
          height="20px"
          width="20px"
          class="chat__paperclip-icon"
        />
        <u>Klik hier om het verstuurde bestand te bekijken</u>
      </p>
      <p class="chat__time">{{ chat.time }}</p>
    </div>
    <div v-else>
      <p>{{ chat.message }}</p>
      <p class="chat__time">{{ chat.time }}</p>
    </div>
    <input
      id="chat__button"
      type="button"
      value="Reageer"
      @click="isHidden = !isHidden"
    />
    <div id="chat__reply" v-if="replies.length != 0">
      <strong>U reageerde:</strong>
      <div v-for="reply in replies" :key="reply">
        {{ reply.message }}
        <p class="chat__time">{{ reply.time }}</p>
      </div>
    </div>
    <div v-if="!isHidden" id="chatInput">
      <div id="chatInput__container">
        <input
          id="chatInput__container__input"
          type="text"
          placeholder="Typ hier je bericht"
          autocomplete="off"
          required
          v-model="message"
        />
        <input
          id="chatInput__container__button"
          @click="sendReply"
          
        />
      </div>
    </div>
  </div>

  <div class="overlay" />

  <div id="myPreviewModal" class="modal">
    <div class="modal-preview__content">
      <svg-icon
        @click="closePreviewModal"
        icon="close"
        fill="#FF5500"
        height="20px"
        width="20px"
        class="modal-preview__content__close-icon"
      />
      <div id="chatPreview" class="modal-preview__content__preview" />
      <div>
        <p id="file-message" class="modal-preview__content__message"></p>
      </div>
    </div>
  </div>
</template>

<script>
import "firebase/firebase-storage";
import db from "@/firebase/firebaseInit";
import SvgIcon from "@/components/SvgIcon.vue";

export default {
  data() {
    return {
      message: null,
      isHidden: true,
      replies: [],
    };
  },
  created() {
    this.lookForReply();
  },
  props: {
    chat: Object,
  },
  components: {
    SvgIcon,
  },
  methods: {
    previewFile() {
      db.storage()
        .ref(this.chat.message)
        .getMetadata()
        .then((metadata) => {
          var currentElement = document.querySelector("#chatPreview");
          if (metadata.contentType.match("image/*")) {
            var newImageElement = document.createElement("img");
            newImageElement.setAttribute("id", "chatPreview");
            newImageElement.setAttribute(
              "class",
              "modal-preview__content__preview"
            );
            currentElement.parentNode.replaceChild(
              newImageElement,
              currentElement
            );
          } else if (metadata.contentType.match("video/*")) {
            var newIframeElement = document.createElement("iframe");
            newIframeElement.setAttribute("id", "chatPreview");
            newIframeElement.setAttribute(
              "class",
              "modal-preview__content__preview"
            );
            currentElement.parentNode.replaceChild(
              newIframeElement,
              currentElement
            );
          } else if (metadata.contentType.match("audio/*")) {
            var newAudioElement = document.createElement("audio");
            newAudioElement.setAttribute("id", "chatPreview");
            newAudioElement.setAttribute(
              "class",
              "modal-preview__content__preview"
            );
            newAudioElement.setAttribute("controls", "true");
            newAudioElement.setAttribute("preload", "auto");
            currentElement.parentNode.replaceChild(
              newAudioElement,
              currentElement
            );
          }
        });
      db.storage()
        .ref(this.chat.message)
        .getDownloadURL()
        .then(function (url) {
          var preview = document.getElementById("chatPreview");
          preview.src = url;
        });
      if (this.chat.fileMessage != "") {
        document.getElementById("file-message").style.color = "black";
        document.getElementById("file-message").style.fontStyle = "normal";
        document.getElementById(
          "file-message"
        ).innerHTML = this.chat.fileMessage;
      } else {
        document.getElementById("file-message").style.color = "grey";
        document.getElementById("file-message").style.fontStyle = "italic";
        document.getElementById("file-message").innerHTML =
          "Er is geen bericht met dit bestand mee gestuurd";
      }

      this.showPreviewModal();
    },
    showPreviewModal() {
      document.getElementById("myPreviewModal").style.display = "block";
    },
    closePreviewModal() {
      document.getElementById("myPreviewModal").style.display = "none";
      var currentElement = document.querySelector("#chatPreview");
      var newElement = document.createElement("div");
      newElement.setAttribute("id", "chatPreview");
      currentElement.parentNode.replaceChild(newElement, currentElement);
    },
    lookForReply() {
      db.firestore()
        .collection("replies")
        .orderBy("time")
        .get()
        .then((snapshot) => {
          snapshot.docs.forEach((doc) => {
            if (
              doc.data().uid == this.chat.uid &&
              doc.data().user == this.chat.user &&
              doc.data().messageBeingRelpiedTo == this.chat.message
            ) {
              this.replies.push({
                message: doc.data().message,
                time: doc.data().time,
              });
            }
          });
        });
    },
    sendReply() {
      db.firestore()
        .collection("messages")
        .add({
          user: this.chat.user,
          message: this.message,
          uid: this.chat.uid,
          time: new Date().toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          }),
          day: new Date().getDate().toString(),
          month: (new Date().getMonth() + 1).toString(),
          fromAdmin: true,
        });
      db.firestore()
        .collection("replies")
        .add({
          user: this.chat.user,
          message: this.message,
          uid: this.chat.uid,
          time: new Date().toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          }),
          day: new Date().getDate().toString(),
          month: (new Date().getMonth() + 1).toString(),
          messageBeingRelpiedTo: this.chat.message,
        });
    },
  },
};
</script>

<style lang="scss">
.chat {
  width: 400px;
  margin-bottom: 20px;
  margin-left: 40px;
  max-width: 700px;
  background-color: lightgray;
  box-sizing: border-box;
  border-radius: 5px;
  box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
  padding: 8px 8px 12px;
  font-family: "Lato";
  font-size: 16px;
  color: black;
  h2 {
    font-weight: bold;
    font-size: 18px;
    display: inline;
  }
  h3 {
    float: right;
  }
  h5 {
    font-weight: normal;
  }
  .chat__paperclip-icon {
    display: inline-block;
    padding-right: 5px;
  }
  .chat__time {
    opacity: 0.7;
    font-size: 12px;
    text-align: right;
    margin-top: 4px;
  }
}

.modal {
  display: none;
  position: fixed;
  z-index: 999;
  top: calc(65vh - 315px);
  height: 50%;
  width: 50%;
  left: calc(25%);
  box-sizing: border-box;
  background-color: #f1f1f1;
  box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 16px;
  font-family: "Lato";
  opacity: 1 !important;

  .modal-preview__content {
    height: 283px;
    display: flex;
    justify-content: center;

    .modal-preview__content__close-icon {
      position: absolute;
      right: 16px;
    }
    audio {
      display: block !important;
      width: 100% !important;
      filter: sepia(20%) saturate(70%) grayscale(1) contrast(99%) invert(12%);
      height: 95px !important;
    }

    .modal-preview__content__preview {
      display: inline;
      box-sizing: border-box;
      margin: auto;
      margin-top: 30px;
      margin-bottom: 50px;
      max-width: 268px;
      width: auto;
      height: 150px;
      z-index: 5;
    }

    .modal-preview__content__message {
      background-color: white;
      height: 88px;
      position: absolute;
      left: 0px;
      top: 350px;
      padding: 8px 8px;
      margin: 0px 16px;
      width: calc(100% - 32px);
      box-sizing: border-box;
      border-radius: 5px;
      overflow-y: scroll;
    }
  }
}

#chatPreview {
  width: auto;
  height: 150px;
}

#chat__reply {
  margin-top: 8px;
  background-color: rgb(220, 220, 220);
  box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.2);
  padding: 8px;
}

#chatInput {
  height: 73px;
  width: 100%;

  #chatInput__container {
    padding: 16px;
    margin: auto;
    margin-top: 12px;
    max-width: 736px;
    position: relative;
    z-index: 999;

    #chatInput__container__input {
      width: calc(100% - 54px);
      box-sizing: border-box;
      height: 44px;
      border: 2px solid #959694;
      border-radius: 999px;
      background-color: transparent;
      padding: 0px 16px 0px 46px;
      font-size: 18px;
    }

    #chatInput__container__button {
      appearance: none;
      background: transparent;
      background-image: url(../../assets/chat/button-send.svg);
      background-repeat: no-repeat;
      border: none;
      position: absolute;
      right: 16px;
      box-sizing: border-box;
      width: 44px;
      height: 44px;
    }
  }
}
</style>